<template>
    <div id="app">
        <!--<img src="./assets/logo.png">-->
        <!--<template v-if="isBackend">-->
        <template v-if="$route.path.indexOf('/backend/') >= 0">
            <app-backend-header></app-backend-header>
            <div id="wrapper" class="app-sidebar-right">
                <!-- Sidebar -->
                <app-sidebar></app-sidebar>
                <router-view></router-view>
            </div>
        </template>
        <template v-else-if="$route.path.indexOf('/directory/') >= 0">
            <app-extension-header></app-extension-header>
            <div id="wrapper" class="app-sidebar-right">
                <!-- Sidebar -->
                <app-extension-sidebar></app-extension-sidebar>
                <router-view></router-view>
            </div>
        </template>
        <template v-else-if="$route.path.indexOf('/print/') >= 0">
            <print-header></print-header>
            <router-view></router-view>
            <print-footer></print-footer>
        </template>
        <template v-else-if="$route.path.indexOf('/token') >= 0">
            <router-view></router-view>
        </template>
        <template v-else>
            <app-header></app-header>
            <router-view></router-view>
            <app-footer></app-footer>
        </template>
    </div>
</template>

<script>
    import Header from '@/components/partials/Header';
    import Footer from '@/components/partials/Footer';
    import ExtensionHeader from '@/components/backend/partials/ExtensionHeader';
    import BackendHeader from '@/components/backend/partials/BackendHeader';
    import Sidebar from '@/components/backend/partials/Sidebar';
    import ExtensionSidebar from '@/components/backend/partials/ExtensionSidebar';
    import BackendFooter from '@/components/backend/partials/Footer';
    import PrintHeader from '@/components/backend/contactextension/print/Header';
    import PrintFooter from '@/components/backend/contactextension/print/Footer';
    import Vue from "vue";
    import linkify from "vue-linkify";
    Vue.directive('linkified', linkify);

    export default {
        name: 'App',
        data() {
            return {
                isBackend: true,
            }
        },
        components: {
            'app-header': Header,
            'app-footer': Footer,
            'app-extension-header': ExtensionHeader,
            'app-backend-header': BackendHeader,
            'app-backend-footer': BackendFooter,
            'app-sidebar': Sidebar,
            'app-extension-sidebar': ExtensionSidebar,
            'print-header': PrintHeader,
            'print-footer': PrintFooter,
        },
    }
</script>



// WEBPACK FOOTER //
// src/App.vue